import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, letting later Tailwind utilities win over earlier ones.
 *
 * This is React Native Reusables' own helper, unchanged. Every component in this
 * package takes a `className` that is passed through here, which is what makes
 * `<Button className="h-12">` override the size variant's `h-9` rather than
 * losing to it on specificity.
 *
 * @param inputs Class values: strings, arrays, or conditional objects.
 * @returns The merged class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
